import * as actionTypes from "./quickCreateTypes";

const INITIAL_STATE = {
    qcEquipmentPartsList: [],
    qcProblemList: [],
    qcSubProblemList: [],
    labelPrintEqList: [],
    scanDetails: null,
};

const quickCreateReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SETQCEQUIPMENTPARTSLIST:
            return {
                ...state,
                qcEquipmentPartsList: action.payload.list,
            };
        case actionTypes.SEQCPROBLEMLIST:
            return {
                ...state,
                qcProblemList: action.payload.list,
            };
        case actionTypes.SETQCSUBPROBLEMLIST:
            return {
                ...state,
                qcSubProblemList: action.payload.list,
            };
        case actionTypes.SETLABELPRINTEQLIST:
            return {
                ...state,
                labelPrintEqList: action.payload.list,
            };
        case actionTypes.SETSCANDETAILS:
            return {
                ...state,
                scanDetails: action.payload.list,
            };
        default:
            return state;
    }
};

export default quickCreateReducer;
